export const liverModuleOverview = [
  {
    id: "anatomy",
    title: "Liver Anatomy",
    description: "Learn the structure of the liver",
    icon: "❤️",
    customImage: "module-liver-anatomy.png",
    gradient: "from-yellow-100 via-pink-50 to-rose-300 border-red-300",
  },
  {
    id: "histology",
    title: "Liver Histology",
    description: "Microscopic structure of the liver",
    icon: "🔬",
    customImage: "module-liver-histology.png",
    gradient: "from-yellow-50 via-yellow-50 to-pink-300 border-rose-300",
  },
  {
    id: "physiology",
    title: "Liver Physiology",
    description: "Metabolism and detoxification",
    icon: "⚡",
    gradient: "from-yellow-100 via-pink-50 to-rose-300 border-red-300",
  },
];
